import React from 'react'

function NewUser() {
  return (
    <>
      <h2 className="u-marginTop0 u-marginBottom2gu">New User?</h2>
      <p className="u-marginBottom2gu u-paddingBottom14gu u-sm-paddingBottom0">
        Register for full access to online resources for financial professionals
        including business-building ideas, investor-approved materials, and
        more.
      </p>
      <a
        href="/register"
        className="Button Button--primary Button--block u-marginBottom4gu u-textColorWhite"
        data-tracking="tertiary"
      >
        Register Now
      </a>
      <p className="u-textSizeMsrm1">
        <strong>For U.S. Advisors only</strong>
      </p>
    </>
  )
}

export default NewUser
